import configuration from "../../configuration";
import ODataFulogicsStore from "fulogics-ui-core/dist/api/odata/ODataFulogicsStore";
import {createModel} from "@rematch/core";
import {iRootModel} from "../iRootModel";

export const ReturnStepOriginLocationsODataEndpoint = `${configuration.API_BASE_URL}/odata/ReturnStepOriginLocations/Store`;
export const ReturnStepOriginLocationsStore = ODataFulogicsStore({
        url: ReturnStepOriginLocationsODataEndpoint,
        key: 'id',
        keyType: 'String',
    });

export type ReturnStepOriginLocationsState = {}

export const ReturnStepOriginLocationsModel = createModel<iRootModel>()({
    state: {} as ReturnStepOriginLocationsState,

    effects: (dispatch) => ({
        
    }),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() // OrderStepReturnData
        {
            return ReturnStepOriginLocationsStore;
        }
    }),
})

export default ReturnStepOriginLocationsModel;